'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectMsaId = exports.removeActivityFilter = exports.addActivityFilter = exports.setSelectedStudioId = exports.enableMap = exports.setMsaId = exports.SET_SELECTED_STUDIO_ID = exports.ENABLE_MAP = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_MSA = 'classpass/sell-experience/SET_MSA';
var ENABLE_MAP = exports.ENABLE_MAP = 'classpass/sell-experience/ENABLE_MAP';
var SET_SELECTED_STUDIO_ID = exports.SET_SELECTED_STUDIO_ID = 'classpass/sell-experience/SET_SELECTED_STUDIO_ID';
var ADD_ACTIVITY_FILTER = 'classpass/sell-experience/ADD_ACTIVITY_FILTER';
var REMOVE_ACTIVITY_FILTER = 'classpass/sell-experience/REMOVE_ACTIVITY_FILTER';

var initialState = {
  mapEnabled: false,
  msaId: 0,
  selectedStudioId: null,
  activityFilters: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case ENABLE_MAP:
    case SET_SELECTED_STUDIO_ID:
    case SET_MSA:
      return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, action.data.key, action.data.value));
    case ADD_ACTIVITY_FILTER:
      return (0, _extends4.default)({}, state, { activityFilters: state.activityFilters.concat([action.data]) });
    case REMOVE_ACTIVITY_FILTER:
      return (0, _extends4.default)({}, state, { activityFilters: state.activityFilters.filter(function (activity) {
          return activity !== action.data;
        }) });
    default:
      return state;
  }
}

var setMsaId = exports.setMsaId = function setMsaId(msaId) {
  return { type: SET_MSA, data: { key: 'msaId', value: parseInt(msaId, 10) || 0 } };
};
var enableMap = exports.enableMap = function enableMap() {
  return { type: ENABLE_MAP, data: { key: 'mapEnabled', value: true } };
};
var setSelectedStudioId = exports.setSelectedStudioId = function setSelectedStudioId(studioId) {
  return { type: SET_SELECTED_STUDIO_ID, data: { key: 'selectedStudioId', value: studioId } };
};
var addActivityFilter = exports.addActivityFilter = function addActivityFilter(activity) {
  return { type: ADD_ACTIVITY_FILTER, data: activity };
};
var removeActivityFilter = exports.removeActivityFilter = function removeActivityFilter(activity) {
  return { type: REMOVE_ACTIVITY_FILTER, data: activity };
};

var selectMsaId = exports.selectMsaId = function selectMsaId(state) {
  return state.features.homepage.msaId;
};